const apiURL = "https://www.setster.com/api/v2/";
const apiEmail = "mur.admin@uwaterloo.ca";
let companyId = null;
let locationId = null;
let murHost = null;
let appHost = null;
let overrides = null;
let calendarURL = null;

if (process.env.NODE_ENV == 'production') {
  companyId = 18245; // Set to prod company
  locationId = 31957; // set to prod campus location
  murHost = "https://mur.uwaterloo.ca/setster/"; 
  appHost = "https://mur.uwaterloo.ca/future-students/tours";
  overrides = {
    duration: {
      '59745': 90,
      '60593': 90,
    }
  };
  calendarURL = murHost + "calendar.json";
} else {
  companyId = 18446; // Set to dev company
  locationId = 32293; // set to dev campus location
  murHost = "https://mur-dev.uwaterloo.ca/setster/"; 
  // const appHost = "http://localhost:8080";
  appHost = "https://mur-dev.uwaterloo.ca/future-students/tours";
  overrides = {
    duration: {
      '60132': 90,
    }
  };
  calendarURL = murHost + "calendar.json";
}

const cancelUrl = "https://www.setster.com/widget/cancel_appointment.php";

const statuses = {
  0: "Unverified",
  1: "Unconfirmed",
  2: "Confirmed",
  3: "Cancelled",
  8: "Completed",
  9: "No Show",
  10: "In Progress",
  11: "Checked In",
  12: "Just Arrived",
  13: "Delayed",
};

const daysAhead = 250; // Days ahead to allow selecting in the calendar.
const maxGroupSize = 4;  // Max number of members allowed per group.
const nextEntryYearMonth = 6; // (6 = July) Month to roll over to next year for entry_year fields.  Zero indexed (0 = Jan, 11 = Dec)

const tourSchedule = {
  fields: [
    {key: 'day', label: 'Day of week'},
    {key: 'campus', label: 'Campus'},
    {key: 'faculty', label: 'Faculties'},
    {key: 'colleges', label: 'University Colleges'},
  ],
  items: [
    { day: 'Monday', campus: "all", faculty: "some", colleges: "all" },
    { day: 'Tuesday', campus: "all", faculty: "some", colleges: "all" },
    { day: 'Wednesday', campus: "all", faculty: "all", colleges: "all" },
    { day: 'Thursday', campus: "all", faculty: "some", colleges: "all" },
    { day: 'Friday', campus: "all", faculty: "some", colleges: "some" },
    { day: 'Saturday', campus: "all", faculty: "none", colleges: "some" },
    { day: 'Sunday', campus: "none", faculty: "none", colleges: "none" },
  ]
};

export { apiEmail, apiURL, statuses, companyId, locationId, cancelUrl, murHost, appHost, maxGroupSize, overrides, daysAhead, tourSchedule, nextEntryYearMonth, calendarURL };
